module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_8017.4cf31dd0.png";